// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: a6Bcof-mnj

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import EditIcon from "../../EditIcon"; // plasmic-import: qgkS2GV7Eb/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSourceCategoryIcon.module.css"; // plasmic-import: a6Bcof-mnj/css

import IconsSourcesYoutubeIcon from "./icons/PlasmicIcon__IconsSourcesYoutube"; // plasmic-import: 9FfsM2N0XvJ/icon
import IconsSourcesTwitterIcon from "./icons/PlasmicIcon__IconsSourcesTwitter"; // plasmic-import: IHgvvrO0sLs/icon
import IconsSourcesRssIcon from "./icons/PlasmicIcon__IconsSourcesRss"; // plasmic-import: 6X_1nliyu7r/icon
import HhLogoSmallsvgIcon from "./icons/PlasmicIcon__HhLogoSmallsvg"; // plasmic-import: m0fZav8zv/icon
import SpotifyLogoIcon from "./icons/PlasmicIcon__SpotifyLogo"; // plasmic-import: 7r3Uzwe2O/icon

createPlasmicElementProxy;

export type PlasmicSourceCategoryIcon__VariantMembers = {
  sourceCategoryType: "youtube" | "twitter" | "websites" | "hubHub" | "spotify";
  hover: "hover";
};
export type PlasmicSourceCategoryIcon__VariantsArgs = {
  sourceCategoryType?: SingleChoiceArg<
    "youtube" | "twitter" | "websites" | "hubHub" | "spotify"
  >;
  hover?: SingleBooleanChoiceArg<"hover">;
};
type VariantPropType = keyof PlasmicSourceCategoryIcon__VariantsArgs;
export const PlasmicSourceCategoryIcon__VariantProps =
  new Array<VariantPropType>("sourceCategoryType", "hover");

export type PlasmicSourceCategoryIcon__ArgsType = {};
type ArgPropType = keyof PlasmicSourceCategoryIcon__ArgsType;
export const PlasmicSourceCategoryIcon__ArgProps = new Array<ArgPropType>();

export type PlasmicSourceCategoryIcon__OverridesType = {
  root?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
  editIcon?: p.Flex<typeof EditIcon>;
};

export interface DefaultSourceCategoryIconProps {
  sourceCategoryType?: SingleChoiceArg<
    "youtube" | "twitter" | "websites" | "hubHub" | "spotify"
  >;
  hover?: SingleBooleanChoiceArg<"hover">;
  className?: string;
}

const $$ = {};

function PlasmicSourceCategoryIcon__RenderFunc(props: {
  variants: PlasmicSourceCategoryIcon__VariantsArgs;
  args: PlasmicSourceCategoryIcon__ArgsType;
  overrides: PlasmicSourceCategoryIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "sourceCategoryType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.sourceCategoryType
      },
      {
        path: "hover",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hover
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover
  };

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.roothover]: hasVariant($state, "hover", "hover"),
          [sty.rootsourceCategoryType_hubHub]: hasVariant(
            $state,
            "sourceCategoryType",
            "hubHub"
          ),
          [sty.rootsourceCategoryType_twitter]: hasVariant(
            $state,
            "sourceCategoryType",
            "twitter"
          ),
          [sty.rootsourceCategoryType_websites]: hasVariant(
            $state,
            "sourceCategoryType",
            "websites"
          )
        }
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <p.PlasmicIcon
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        PlasmicIconType={
          hasVariant($state, "sourceCategoryType", "spotify")
            ? SpotifyLogoIcon
            : hasVariant($state, "sourceCategoryType", "hubHub")
            ? HhLogoSmallsvgIcon
            : hasVariant($state, "sourceCategoryType", "websites")
            ? IconsSourcesRssIcon
            : hasVariant($state, "sourceCategoryType", "twitter")
            ? IconsSourcesTwitterIcon
            : IconsSourcesYoutubeIcon
        }
        className={classNames(projectcss.all, sty.svg, {
          [sty.svghover]: hasVariant($state, "hover", "hover"),
          [sty.svgsourceCategoryType_hubHub]: hasVariant(
            $state,
            "sourceCategoryType",
            "hubHub"
          ),
          [sty.svgsourceCategoryType_spotify]: hasVariant(
            $state,
            "sourceCategoryType",
            "spotify"
          ),
          [sty.svgsourceCategoryType_twitter]: hasVariant(
            $state,
            "sourceCategoryType",
            "twitter"
          ),
          [sty.svgsourceCategoryType_websites]: hasVariant(
            $state,
            "sourceCategoryType",
            "websites"
          )
        })}
        role={"img"}
      />

      <EditIcon
        data-plasmic-name={"editIcon"}
        data-plasmic-override={overrides.editIcon}
        className={classNames("__wab_instance", sty.editIcon, {
          [sty.editIconhover]: hasVariant($state, "hover", "hover")
        })}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg", "editIcon"],
  svg: ["svg"],
  editIcon: ["editIcon"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  svg: "svg";
  editIcon: typeof EditIcon;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSourceCategoryIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSourceCategoryIcon__VariantsArgs;
    args?: PlasmicSourceCategoryIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSourceCategoryIcon__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSourceCategoryIcon__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSourceCategoryIcon__ArgProps,
          internalVariantPropNames: PlasmicSourceCategoryIcon__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSourceCategoryIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSourceCategoryIcon";
  } else {
    func.displayName = `PlasmicSourceCategoryIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicSourceCategoryIcon = Object.assign(
  // Top-level PlasmicSourceCategoryIcon renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),
    editIcon: makeNodeComponent("editIcon"),

    // Metadata about props expected for PlasmicSourceCategoryIcon
    internalVariantProps: PlasmicSourceCategoryIcon__VariantProps,
    internalArgProps: PlasmicSourceCategoryIcon__ArgProps
  }
);

export default PlasmicSourceCategoryIcon;
/* prettier-ignore-end */
